export default __webpack_public_path__ + "static/media/icon-reduce.975a571e.svg";